export default "__VITE_ASSET__D8ios2i7__"